import { topicItems } from '@/mocks/homeData';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900">
            热门话题
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500">
            51影院社区最热讨论话题，看看影迷们都在关注什么
          </p>
        </div>
        <div className="flex flex-wrap justify-center gap-3 md:gap-4">
          {topicItems.map((topic) => (
            <a
              key={topic.name}
              href="#cards"
              onClick={(e) => { e.preventDefault(); document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' }); }}
              className="group inline-flex items-center gap-2 px-4 py-2.5 md:px-5 md:py-3 rounded-full bg-background-50 border border-background-200 hover:border-primary-300 hover:bg-primary-50 transition-all duration-200 cursor-pointer"
            >
              <span className="text-sm md:text-base font-medium text-foreground-700 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                #{topic.name}
              </span>
              <span className="text-xs text-foreground-400 whitespace-nowrap">
                {topic.count}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}